import {
  getPortionTarget,
  isPortionOptionGroup,
  resolveEffectivePortionQuantities,
  toPortionShares,
} from "@/lib/option-group-portions";
import type { OptionGroup } from "@/types";
import { PRICE_STRATEGIES, type GroupQuantities } from "./strategies";

/**
 * Price contribution of a single option group for the raw selected quantities
 * (optionId -> qty), on whole option prices. AVG/MAX groups are portioned: each
 * pick is priced by its share of the selection (one of two picks = 1/2), so AVG
 * is the weighted mean and MAX the top price. Never rounds.
 */
export function priceGroupTotal(group: OptionGroup, rawQuantities: GroupQuantities): number {
  const options = group.options ?? [];
  const strategy = PRICE_STRATEGIES[group.priceMethod] ?? PRICE_STRATEGIES.SUM;

  const portionTarget = getPortionTarget(group);
  if (isPortionOptionGroup(group) && portionTarget) {
    const shares = toPortionShares(resolveEffectivePortionQuantities(rawQuantities ?? {}, portionTarget), portionTarget);
    return strategy(options, shares, 1);
  }

  return strategy(options, rawQuantities ?? {});
}
